<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="18">
              <el-select v-model="cangkucode" placeholder="发货仓库" style="width: 150px;" :clearable="true" @change="bindGrid">
                <el-option v-for="item in jxcstoreDatas" :key="item.cangkucode"
                           :label="item.cangkuname" :value="item.cangkucode">
                </el-option>
              </el-select>
              <el-select v-model="cangkucode2" placeholder="收货仓库" style="width: 150px;" :clearable="true" @change="bindGrid">
                <el-option v-for="item in jxcstoreDatas" :key="item.cangkucode"
                           :label="item.cangkuname" :value="item.cangkucode">
                </el-option>
                <el-option v-for="item in jxcStoreThird" :key="item.cangkucode"
                           :label="item.cangkuname" :value="item.cangkucode">
                </el-option>
              </el-select>
              <el-input style="width:150px;"
                        placeholder="调拨单号"
                        prefix-icon="el-icon-search"
                        v-model="erpserial">
              </el-input>
              <el-select v-model="datesearch" placeholder="按发货时间" style="width: 150px;">
                <el-option key="10" label="按录入时间" value="10"></el-option>
                <el-option key="20" label="按发货时间" value="20"></el-option>
                <el-option key="30" label="按到货时间" value="30"></el-option>
              </el-select>
              <el-date-picker style="width:150px"
                              v-model="begindate" :value-format="'yyyy-MM-dd'"
                              type="date"
                              placeholder="开始日期">
              </el-date-picker>
              <el-date-picker style="width:150px"
                              v-model="enddate" :value-format="'yyyy-MM-dd'"
                              type="date"
                              placeholder="结束日期">
              </el-date-picker>
              <el-select v-model="logisticsco" placeholder="请选择" style="width: 150px;">
                <el-option
                  v-for="item in parameterData"
                  :key="item.value"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
              <el-input placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel"
                        style="width:150px;"
                        @clear="clearSeedCode">
              </el-input>
              <el-input style="width:150px;"
                        placeholder="物流单号"
                        prefix-icon="el-icon-search"
                        v-model="logisticsnum">
              </el-input>
              <el-radio-group v-model="status" size="mini" @change="bindInit">
                <el-radio-button :label="''" :key="''">全部</el-radio-button>
                <el-radio-button :label="'-20'" :key="'-20'">待审核</el-radio-button>
                <el-radio-button :label="'-10'" :key="'-10'">待发货</el-radio-button>
                <el-radio-button :label="'0'" :key="'0'">待收货</el-radio-button>
                <el-radio-button :label="'10'" :key="'10'">已办结</el-radio-button>
              </el-radio-group>
            </el-col>
            <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid(false)">搜索
            </el-button>
            <el-button type="success" @click="excelPort" size="mini">导出</el-button>
            <el-button type="warning" v-on:click="allocation('','',0,'')" v-if="roletype=='order'">调拨</el-button>
            <el-button type="warning" v-on:click="allocation('','',0,'80')" v-if="roletype=='order'&&useFrame()">镜架调拨</el-button>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight(160)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            fixed
            prop="erpserial"
            label="调拨单号"
            align="center"
            width="130"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="pingpai" :show-overflow-tooltip="true"
            label="品牌"
            align="left"
            width="80"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="seedname" :show-overflow-tooltip="true"
            label="名称"
            align="left"
            width="150"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="seedcode" :show-overflow-tooltip="true"
            label="编码"
            align="center"
            width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="cangkuname" :show-overflow-tooltip="true"
            label="发货仓"
            align="left"
            width="90"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="cangkuname2" :show-overflow-tooltip="true"
            label="收货仓"
            align="left"
            width="90"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="totalnumber"
            label="总数"
            align="center"
            width="60"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="uname"
            label="开单人"
            align="left"
            width="80" :show-overflow-tooltip="true"
            text-align="center">
          </el-table-column>
          <el-table-column
            align="center"
            label="开单日期" width="90">
            <template slot-scope="scope">
              {{(scope.row.adddate || "").substring(0,10)}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="发货日期" width="140">
            <template slot-scope="scope">
              {{(scope.row.accdate || "")}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="收货日期" width="140">
            <template slot-scope="scope">
              {{(scope.row.handleoverdate || "")}}
            </template>
          </el-table-column>
          <el-table-column
            prop="logisticsco"
            label="物流公司" :show-overflow-tooltip="true"
            align="left"
            width="120"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="logisticsnum" :show-overflow-tooltip="true"
            label="物流单号"
            align="left"
            width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            label="状态"
            align="left"
            fixed="right"
            width="60"
            text-align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status==-20" style="color:red">待审核</span>
              <span v-if="scope.row.status==-10&&roletype=='order'">待发货</span>
              <span v-if="scope.row.status==-10&&roletype=='store'" style="color:red">待发货</span>
              <!--<span v-if="scope.row.status==-10&&scope.row.printCount==undefined" style="color:red"> 未打印</span>-->
              <span v-if="scope.row.status==0" style="color:blue">待收货</span>
              <span v-if="scope.row.status==10">已办结</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button size="mini" type="success"
                         v-if="roletype=='store'&&scope.row.status==-10&&manageCangKu(scope.row.cangkucode)"
                         @click="fahuo(scope.$index, scope.row)">发货
              </el-button>
              <el-button size="mini" type="danger"
                         v-if="roletype=='store'&&scope.row.status==0&&manageCangKu(scope.row.cangkucode2)"
                         @click="handlesaleCsagreementToVoid(scope.$index, scope.row)">收货
              </el-button>
              <el-button size="mini" v-if="roletype=='order'&& (!independentserial&&scope.row.status==-20 )"
                         v-on:click="allocation(scope.$index, scope.row,1)">审核
              </el-button>
              <el-button size="mini"
                         v-if="roletype=='order'&&( (!independentserial&&scope.row.status==-10)||(independentserial&&scope.row.status==-20) )"
                         v-on:click="allocation(scope.$index, scope.row,1)">修改
              </el-button>
              <el-button size="mini"
                         v-if="roletype=='order'&&((!independentserial&&scope.row.status==-10)||scope.row.status==-20)"
                         @click="deleteRow(scope.$index, scope.row)">删除
              </el-button>
              <el-button size="mini" v-else @click="lookDetails(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
        <AllocationDetail ref="DataContactDetail" @bindGrid="bindGrid"></AllocationDetail>
        <AllocationEditNew ref="DataContactEdit2" @bindGrid="bindGrid"></AllocationEditNew>
        <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
      </div>
    </el-col>
  </div>
</template>

<script>
  import {getjxcList, updatejxc, deleteData} from '@/api/set/allocation';
  import AllocationDetail from './AllocationDetail';
  import AllocationEditNew from './AllocationEditNew';
  import {getListDataall,thirdStore} from '@/api/set/jxcstore';
  import {getParameterDetail} from '@/api/set/parameter';
  import JxcgooddetailSel from '@/components/set/jxcgooddetail/JxcgooddetailSel'

  export default {
    name: 'AllocationListNew',
    data() {
      return {
        msg: '调拨单',
        dialogFormVisible: false,
        searchdata: "",
        begindate: this.begindate,
        enddate: this.enddate,
        loading: true,
        status: "",
        seedcode: "",
        categorycode: '',
        seedname: '',
        dataname: "",
        seedgoods: '',
        datesearch: '20',
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        controlData: {},
        isshwoupdate: '',
        independentserial: '',
        jxcstoreDatas: [],
        jxcStoreThird:[],
        cangkucode: '',
        cangkucode2: '',
        erpserial: '',
        uname: '',
        cangkuname2: '',
        seedinfo: '',
        logisticsco: '',
        logisticsnum: '',
        parameterData: [],
        cangkumanage: '',
      }
    },
    props: {
      mystatus: {
        default: ''
      },
      roletype: {
        default: ''
      },
      canMultySelect: {
        default: true
      }
    },
    methods: {
      useFrame(){
        if(localStorage.getItem("hpapi_usemodel")&&localStorage.getItem("hpapi_usemodel")=='noframe'){
          return false;
        }
        return true;
      },
      manageCangKu(cangkucode) {//管理的仓库
        if (this.cangkumanage.indexOf(';' + cangkucode + ';') > -1)
          return true;
        return false;
      },
      lookDetails(index, row) {
        this.$refs.DataContactDetail.initData(row)
        this.OpenDialog()
      },
      fahuo(index, row) {
        this.$refs.DataContactDetail.initData(row, 'fahuo')
        this.OpenDialog()
      },
      handlesaleCsagreementToVoid(index, row) {
        this.$refs.DataContactDetail.initData(row, 'shouhuo',this.jxcstoreDatas)
        this.OpenDialog()
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
        this.bindGrid()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = ";" + row.seedcode + ","
        this.seedname = row.seedname
        this.bindGrid()
      },
      deleteRow(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({erpserial: row.erpserial}).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }
            this.bindGrid();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      bindInit() {
        if (this.roletype == 'store') {
          var cangks = this.cangkumanage.split(';')
          for (var ck in cangks) {
            if (cangks[ck] != '') {
              if (this.status == '0') {//待收货
                this.cangkucode2 = cangks[ck];
                this.cangkucode = '';
              } else if (this.status == '-10') {//待发货
                this.cangkucode = cangks[ck];
                this.cangkucode2 = '';
              } else {
                this.cangkucode = '';
                this.cangkucode2 = '';
              }
              break;
            }
          }
        }
        this.bindGrid();
      },
      bindGrid(rebindtip) {
        if (rebindtip)
          this.$emit("bindTip");

        getjxcList({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata,
          begindate: this.begindate,
          enddate: this.enddate,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          formtype: 77,
          erpserial: this.erpserial,
          uname: this.uname,
          cangkucode: this.cangkucode,
          cangkucode2: this.cangkucode2,
          logisticsco: this.logisticsco,
          logisticsnum: this.logisticsnum,
          datesearch: this.datesearch,
          status: this.status
        }).then(response => {
          this.tableData = response.data.obj.rows
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].linkman = this.tableData[i].linkman + this.tableData[i].linkmantel
          }
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
      excelPort() {//导出EXCEL
        var data = []
        var date = new Date();
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        var name = '调拨单' + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)

        getjxcList({
          offset: 0,
          limit: 1000,
          search: this.searchdata,
          begindate: this.begindate,
          enddate: this.enddate,
          seedcode: this.seedcode,
          categorycode: this.categorycode,
          formtype: 77,
          erpserial: this.erpserial,
          uname: this.uname,
          cangkucode: this.cangkucode,
          cangkucode2: this.cangkucode2,
          logisticsco: this.logisticsco,
          logisticsnum: this.logisticsnum,
          datesearch: this.datesearch,
          status: this.status
        }).then(response => {
          var data = response.data.obj.rows

          let header1 = ["调拨单号", "品牌", "商品名称", "商品编码", "发货仓", "收货仓", "数量", "开单人", "开单日期", "发货日期", "收货日期", "物流公司", "物流单号"]
          let column1 = ["erpserial", "pingpai", "seedname", "seedcode", "cangkuname", "cangkuname2", "totalnumber", "uname", "adddate", "accdate", "handleoverdate", "logisticsco", "logisticsnum"]

          this.$exportExcel(header1, column1, data, name)
        }).catch((error) => {
          console.log(error)
        });
      },
      OpenDialog() {
        this.$refs.DataContactDetail.show()
      },
      allocation(index, item, isupdate, filltemplate) {
        this.$refs.DataContactEdit2.show()
        this.$refs.DataContactEdit2.initData(item, isupdate, filltemplate)
      },
    },
    mounted() {
      this.thirdStoreThird=[]
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.cangkumanage = ';' + this.userInfoModel.cangku + ';';
      //默认值
      this.independentserial = this.userInfoModel.independentserial;
      getListDataall().then(response => {
        this.jxcstoreDatas = response.data.obj
        if (this.roletype == 'store') {
          this.status = '-10';//默认待发货状态

          thirdStore(null).then(resThird=>{
            this.jxcStoreThird=resThird.data.obj
          })
        }
        this.bindInit();
      })

      getParameterDetail({paraname: "快递公司"}).then(response => {
        this.parameterData = JSON.parse(response.data.obj.paracontent);
        // if(this.parameterData){
        //   this.parameterData.unshift({value:'',name:'全部'})
        // }
        this.logisticsco = ''
      })
    },
    components: {
      AllocationDetail,
      AllocationEditNew,
      JxcgooddetailSel,

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/warehouse/AllocationListNew.vue